import { REDUX_ROUTING_PAGE_NAMESPACE } from "Common/routingUtils/constants";
import get from "lodash/get";
import { createSelector } from "reselect";
export default createSelector((state) => get(state, `[${REDUX_ROUTING_PAGE_NAMESPACE}].payload.projectId`), (projectId) => projectId && Number.isFinite(Number(projectId)) ? Number(projectId) : undefined);
